<template>
  <a href="#" v-if="show" @click.prevent="addFolder">
    <aw-icon icon="folder-add" class="w-5 h-5 "></aw-icon>
    {{$t('New Folder')}}
  </a>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import AddFolder from '../../mixins/AddFolder'

export default {
  mixins: [AddFolder],
  computed: {
    show () {
      return this.bcFolderStore.current?.can_edit
    },
    ...mapStores(useBcSelectedStore, useBcFolderStore),
  },
}
</script>

<style lang="scss" scoped></style>
